import { PaymentType } from '@/features/orders/constants/app'

const primaryOrder: PaymentType[] = [PaymentType.Cash, PaymentType.CardOnsite]

export const sortPaymentTypesVisualOrder = (paymentTypes: PaymentType[]): PaymentType[] => {
    const primaryPaymentTypes = primaryOrder.filter((paymentType) =>
        paymentTypes.includes(paymentType)
    )
    const extraPaymentTypes = paymentTypes.filter(
        (paymentType) => !primaryPaymentTypes.includes(paymentType)
    )

    return [...primaryPaymentTypes, ...extraPaymentTypes]
}
